import React from 'react'
import { LocationsQuery, getStateName, ipContainer, IPSubscriber } from '../../core'

import './locations-list.scss'

const defaultData = { locations: [] }

const Location = ({ 
  title, 
  neighborhood, 
  setCustomImage, 
  thumbnailImage, 
  isActive,
  slug,
}) => {
  const onMouseEnter = () => {
    setCustomImage(thumbnailImage)
  }

  const onMouseLeave = () => {
    setCustomImage(null)
  }

  return (
    <a 
      className='_locations-content-link'
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      href={`/locations/${slug}`}
    >
      {!isActive && <h2><b>Coming Soon</b></h2>}
      <h4>{title}</h4>
      <h5>{neighborhood}</h5>
    </a>
  )
}

const LocationsList = ({ data = {}, context = {}, setCustomImage }) => {
  return (
    <IPSubscriber>{() => (
      <LocationsQuery
        render={({ data = defaultData }) => {
          const { locations } = data

          let customLocations = locations.slice()
          
          customLocations = locations.filter(l => (
            l.address && l.address.state
          ))

          const matches = customLocations
            .filter(o => o.address.state === ipContainer.state.region)

          if (matches.length < 1) {
            return (
              <div className='_locations-content'>
                <h5><b>Locations</b></h5>
                <p />
                <h3>
                  We have multiple locations throughout the U.S. 
                  <br />We invite you to visit us.
                </h3>
                <p />
                <p />
                <p />
              
                <a href="/locations">
                  <button>
                  View All Locations
                  </button>
                </a>
              </div>
            )
          }

          const locationsToShow = (matches).map(
            location => ({
              ...location,
              ...locations.find(m => m.id === location.id),
            })
          )

          return (
            <div className='_locations-content'>
              <h5><b>{getStateName(ipContainer.state.region)} Locations</b></h5>
            
              <div className='_locations-content-links'>
                {locationsToShow.map(({ id, ...rest }) => (
                  <Location key={id} {...rest} setCustomImage={setCustomImage} />
                ))}
              </div>
              
              <a href="/locations">
                <button>
                  View All Locations
                </button>
              </a>
            </div>
          )}}
      />
    )}</IPSubscriber>
  )
}

export default LocationsList
